export const defaultButtonsData = [
    {
        color: "primary",
        title: "Primary Button",
        id: "default1",
    },
    {
        color: "secondary",
        id: "default2",
        title: "Secondary Button",
    },
    {
        color: "success",
        id: "default3",
        title: "Success Button",
    },
    {
        color: "info",
        id: "default4",
        title: "Info Button",
    },
    {
        id: "default5",
        color: "warning",
        title: "Warning Button",
    },
    {
        id: "default6",
        color: "danger",
        title: "Danger Button",
    },
    {
        color: "light",
        id: "default7",
        title: "Light Button",
    },
];

export const sizingButtonsData = [
    {
        id: "largeButton1",
        color: "primary",
        size: "lg",
        title: "Primary Button",
    },
    {
        id: "largeButton2",
        color: "secondary",
        size: "lg",
        title: "Secondary Button",
    },
    {
        id: "largeButton3",
        size: "lg",
        color: "success",
        title: "Success Button",
    },
    {
        id: "largeButton4",
        color: "info",
        title: "Info Button",
        size: "lg",
    },
    {
        id: "largeButton5",
        color: "warning",
        size: "lg",
        title: "Warning Button",
    },
    {
        id: "largeButton6",
        size: "lg",
        color: "danger",
        title: "Danger Button",
    },
    {
        id: "largeButton7",
        color: "light",
        size: "lg",
        title: "Light Button",
    },
];

export const activeButtonsData = [
    {
        active: true,
        color: "primary",
        title: "Active",
        id: "active1",
    },
    {
        active: true,
        color: "secondary",
        id: "active2",
        title: "Active",
    },
    {
        active: true,
        color: "success",
        id: "active3",
        title: "Active",
    },
    {
        active: true,
        color: "info",
        id: "active4",
        title: "Active",
    },
    {
        active: true,
        id: "active5",
        color: "warning",
        title: "Active",
    },
    {
        active: true,
        id: "active6",
        color: "danger",
        title: "Active",
    },
    {
        active: true,
        color: "light",
        id: "active7",
        title: "Active",
    },
];


export const outlineButtonsData = [
    {
        outline: true,
        color: "primary",
        title: "Primary Button",
        id: "outLine1",
    },
    {
        outline: true,
        color: "secondary",
        id: "outLine2",
        title: "Secondary Button",
    },
    {
        outline: true,
        color: "success",
        id: "outLine3",
        title: "Success Button",
    },
    {
        outline: true,
        color: "info",
        id: "outLine4",
        title: "Info Button",
    },
    {
        outline: true,
        id: "outLine5",
        color: "warning",
        title: "Warning Button",
    },
    {
        outline: true,
        id: "outLine6",
        color: "danger",
        title: "Danger Button",
    },
    {
        outline: true,
        color: "light",
        id: "outLine7",
        title: "Light Button",
    },
];

export const boldBorderOutlineButtonsData = [
    {
        outline: true,
        color: "primary-2x",
        title: "Primary Button",
        id: "boldBorderOutLine1",
    },
    {
        outline: true,
        color: "secondary-2x",
        id: "boldBorderOutLine2",
        title: "Secondary Button",
    },
    {
        outline: true,
        color: "success-2x",
        id: "boldBorderOutLine3",
        title: "Success Button",
    },
    {
        outline: true,
        color: "info-2x",
        id: "boldBorderOutLine4",
        title: "Info Button",
    },
    {
        outline: true,
        id: "boldBorderOutLine5",
        color: "warning-2x",
        title: "Warning Button",
    },
    {
        outline: true,
        id: "boldBorderOutLine6",
        color: "danger-2x",
        title: "Danger Button",
    },
    {
        outline: true,
        color: "light-2x txt-dark",
        id: "boldBorderOutLine7",
        title: "Light Button",
    },
];

export const gradientButtonsData = [
    {
        color: "primary-gradien",
        title: "Primary Button",
        id: "gradientButtons1",
    },
    {
        color: "secondary-gradien",
        id: "gradientButtons2",
        title: "Secondary Button",
    },
    {
        color: "success-gradien",
        id: "gradientButtons3",
        title: "Success Button",
    },
    {
        color: "info-gradien",
        id: "gradientButtons4",
        title: "Info Button",
    },
    {
        id: "gradientButtons5",
        color: "warning-gradien",
        title: "Warning Button",
    },
    {
        id: "gradientButtons6",
        color: "danger-gradien",
        title: "Danger Button",
    },
];
